import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import Badge from "src/components/Badge"
import { statusToken } from "src/components/Badge/status_tokens"

const STATUS_CONFIG = {
  open: { dotColor: "bg-gray-500" },
  in_progress: { dotColor: "bg-blue-500" },
  work_complete: { dotColor: "bg-supplementary-violet-500" },
  closed: { dotColor: "bg-teal-500" },
}

const WorkOrderStatusBadge = ({ status, statusLabel }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.open

  return (
    <Badge
      variant="small"
      color={statusToken(statusLabel)}
      text={
        <span className="inline-flex items-center gap-2">
          <span
            className={classNames("h-2 w-2 rounded-full", config.dotColor)}
            aria-hidden="true"
          />
          {statusLabel}
        </span>
      }
    />
  )
}

WorkOrderStatusBadge.propTypes = {
  status: PropTypes.oneOf(["open", "in_progress", "work_complete", "closed"])
    .isRequired,
  statusLabel: PropTypes.string.isRequired,
}

export const WORK_ORDER_STATUS_CONFIG = STATUS_CONFIG

export default WorkOrderStatusBadge
